import { useCallback } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  useNotepadInactivityStore,
  WARNING_DURATION_S,
} from "../store/useNotepadInactivityStore";

const EXIT_DURATION_MS = 300;

export function NotepadInactivityToast() {
  const {
    isWarning,
    keepOpen,
    countdown: storeCountdown,
  } = useNotepadInactivityStore();

  const handleKeepOpen = useCallback(() => {
    keepOpen();
  }, [keepOpen]);

  return (
    <AnimatePresence>
      {isWarning && (
        <motion.div
          key="notepad-inactivity-toast"
          initial={{ opacity: 0, y: -16, height: "auto" }}
          animate={{ opacity: 1, y: 0, height: "auto" }}
          exit={{ opacity: 0, y: -16, height: 0 }}
          transition={{ duration: EXIT_DURATION_MS / 1000, ease: "easeOut" }}
          className="flex justify-center pointer-events-none w-full overflow-hidden"
        >
          <div
            className="pointer-events-auto overflow-hidden rounded-[10px]"
            style={{
              background: "#FFF0D1",
              minWidth: 340,
            }}
          >
            {/* Main row */}
            <div className="flex items-center gap-3 px-5 py-[15px]">
              <img
                src="/assets/warning_alt.svg"
                alt="Warning"
                style={{ width: 22, height: 22, flexShrink: 0 }}
              />
              <span
                style={{
                  fontFamily: "'Mulish', sans-serif",
                  fontSize: 15,
                  fontWeight: 700,
                  color: "#1a1a1a",
                  flex: 1,
                  whiteSpace: "nowrap",
                }}
              >
                Looks like you stepped away. The notepad will close in{" "}
                {storeCountdown}s
              </span>
              <button
                onClick={handleKeepOpen}
                style={{
                  fontFamily: "'Mulish', sans-serif",
                  fontSize: 14,
                  fontWeight: 700,
                  color: "#1a1a1a",
                  background: "#FFFFFF",
                  border: "none",
                  borderRadius: 8,
                  padding: "7px 14px",
                  cursor: "pointer",
                  flexShrink: 0,
                  whiteSpace: "nowrap",
                }}
              >
                Keep Open
              </button>
            </div>

            {/* Progress bar */}
            <div style={{ height: 4, background: "#FFE5A0", width: "100%" }}>
              <div
                style={{
                  height: "100%",
                  background: "#FFBB33",
                  animation: `notepadInactivityProgress ${WARNING_DURATION_S}s linear both`,
                }}
              />
            </div>
          </div>
        </motion.div>
      )}
      <style>{`
        @keyframes notepadInactivityProgress {
          from { width: 100%; }
          to   { width: 0%;   }
        }
      `}</style>
    </AnimatePresence>
  );
}
